// @ts-check
import styled from 'styled-components';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';
import SetupImg from 'images/characters/setup-sso.svg';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import { LBButton } from '@linearb/buzz';

const StyledSVG = styled.img`
  width: 10rem;
  height: 12rem;
`;

const EmptyTokensView = () => {
  const history = useHistory();
  const redirectToApiTokens = () => history.push(AppRouter.API_TOKENS.path);

  return (
    <Flex items='center' justify='center' direction='column'>
      <StyledSVG src={SetupImg} />
      <Padding padding='small'>
        <Text color='shuttleGray' size='large'>
          Create an API Token in order to enable SCIM Provisioning
        </Text>
      </Padding>

      <Padding t='small'>
        <LBButton onClick={redirectToApiTokens} size='lg' variant='outline'>
          Create an API Token
        </LBButton>
      </Padding>
    </Flex>
  );
};

export default EmptyTokensView;
